export enum OperationResultType {
  Success = 0,
  Warning = 1,
  Error = 2,
}
